import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAnyStandardEnabled, type IsoStandard } from '../../../constants/isoStandards';
import { selectEnabledStandards, selectOrganizationStandardsStatus } from '../../organizationStandards/organizationStandardsSlice';

interface RequireStandardEnabledProps {
  standards: IsoStandard[];
}

/** Oculta rutas de módulos cuya norma no está habilitada en el tenant. */
export function RequireStandardEnabled({ standards }: RequireStandardEnabledProps) {
  const enabledStandards = useSelector(selectEnabledStandards);
  const standardsStatus = useSelector(selectOrganizationStandardsStatus);

  if (standardsStatus === 'loading' || standardsStatus === 'idle' || enabledStandards === null) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">
        Cargando perfil normativo…
      </div>
    );
  }

  if (!isAnyStandardEnabled(enabledStandards, standards)) {
    return <Navigate to="/perfil" replace />;
  }

  return <Outlet />;
}
